<template>
  <div>
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content"
        v-loading="loadingStaus"
        :element-loading-text="loadingText">
        <el-row :gutter="48">
          <el-form ref="companyForm" :model="formData" :rules="rules" label-width="100px">
            <el-col :span="18">
              <el-form-item v-for="(item,index) in formList" :key="index" :label="item.label" :prop="item.props">
                <el-input v-if="item.type=='select'" disabled :value="item.propsData[formData[item.props]]"></el-input>
                <el-input v-else disabled :value="formData[item.props]"></el-input>
              </el-form-item>
              <el-form-item label="税源地名称" prop="channel_name">
                <el-input disabled :value="formData.channel_name"></el-input>
              </el-form-item>
              <el-form-item label="任务类型" prop="category_name">
                <el-input disabled :value="formData.category_name"></el-input>
              </el-form-item>
              <el-form-item label="任务描述" prop="mission_content" v-if="formData.mission_content">
                <el-input disabled type="textarea" rows="6" :value="formData.mission_content"></el-input>
              </el-form-item>
              <el-form-item label="状态" prop="birthday">
                <el-input disabled type="input" :value="formData.status | TransactionStatus"></el-input>
              </el-form-item>
              <el-form-item label="审核状态" prop="mobile">
                <el-input disabled type="input" :value='formData.examine_status=="1"?"审核成功":formData.examine_status=="2"?"审核失败":"审核中"'></el-input>
              </el-form-item>
              <el-form-item label="失败原因" v-if="formData.examine_status==2" prop="mobile">
                <el-input disabled type="textarea" rows="4" :value="formData.examine_reason"></el-input>
              </el-form-item>
              <el-form-item label="合作邀请码" prop="mobile" v-if="formData.examine_status==1">
				<img :src="formData.code_url" @click="showImage(formData.code_url)" class="QR-code" v-if="formData.code_url"/>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
         <!-- 预览图片弹框 -->
        <el-dialog
          :title="'预览图片'"
          :visible.sync="dialogVisible"
          :modal="false"
          :width="'35%'"
        >
          <div class="block" v-if="dialogVisible">
            <img :src="this.imageUrl" class="preview">
          </div>
        </el-dialog>
      </div>
    </PageHeaderLayout>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import UploadFile from "@/components/UploadFile";
import { mapGetters } from 'vuex'
import {SALARY_TYPE_TEXT} from '@/utils/utils.js'
export default {
  components: {
    PageHeaderLayout,
    UploadFile,
  },
  data() {
    return {
      formList: [
        {
          label: "任务名称",
          props: "title",
        },
        {
          label: "行业类型",
          props: "recruit_type_name",
        },
        {
          label: "工作地点",
          props: "all_address",
        },
        {
          type: 'select',
          label: "结算方式",
          props: "salary_type",
          propsData: SALARY_TYPE_TEXT
        },
        {
          label: "用工人数",
          props: "person_num",
        },
        {
          label: "最低薪资",
          props: "min_salary",
        },
        {
          label: "最高薪资",
          props: "max_salary",
        },
        {
          label: "学历要求",
          type: "select",
          props: "min_qualification",
          propsData: {
            0:"不限",
            1:"小学",
            2:"初中",
            3:"高中",
            4:"大专",
            5:"本科及以上",
          }
        },
      ],
      dialogVisible: false,
      activeTab: '0',
      hearTitle: '基本设置',
      loadingStaus: true,
      loadingText: '正在提交中……',
      formDisabled: false,
      billId:0, // 公司id，0表示创建，非零为编辑
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      // 分类列表
      categoryList:[],
      openapiList:[],
      // 标签
      categoryLabelList:[],
      // 已选中的分类列表，用于cascader组件选中效果
      selectedList:[],
      // 已选中标签
      selectedLabelList:[],
      // 公司基本信息表单结构
      formData:{},
      // 已上传图片列表
      uploadFileList:[],
      // 公司基本信息规则
      rules: {
        name: [
          {required: true, message: '输入公司名称', trigger: 'blur' },
        ],
        file_url: [
          {required: true, message: '输入文件名称', trigger: 'blur' },
        ]
      },
      // 附件类型
      attachmentType:['application/pdf','application/caj','','application/zip','application/rar','application/doc'],
      // 已上传附件列表
      attachmentUploadFileList:[],
      imageUrl: '',//图片地址
    }
  },
  computed: {
    ...mapGetters(['userPermissions']),
  },
  methods: {
    /* 预览图片 */
    showImage(data) {
      this.dialogVisible = true;
      this.imageUrl = data;
    },
    // 初始化公司基本信息
    async init() {
      let url = this.$route.path
      let urlSlashCount=url.split('/').length
      this.action = url.split('/')[urlSlashCount-1].toLowerCase()
      this.formDisabled = (this.action === 'view') ? true : false
      console.log("action -> ", this.formDisabled)
      if (this.$route.params.customer_id) {
        this.id = this.$route.params.customer_id
      }
      if (this.id) {
        let {info} = await this.$api.getCustomerInfo(this.id)
        console.log("formData", info)
        this.formData = info
      }
    },
    //返回上一页
    goBack() {
      this.$router.push({ path: "/mission_center" });
    }
  },
	async mounted() {
		this.formData = this.$route.params;
    if(this.$route.query.task_type=='2'){
      this.formData.title = this.formData.recruit_post;
      this.formData.recruit_type_name = this.formData.industry_type_name;
      this.formData.person_num = this.formData.worked_num;
      this.formData.min_qualification = this.formData.education;
    }
		this.loadingStaus = true
		this.init()
		this.$nextTick(() => {
			this.loadingStaus = false
		})
	},
}
</script>

<style lang="stylus" scoped>
  .content-left
    min-height 640px
    border-right 1px solid  #e8e8e8
    .el-cascader
      display block
      width 320px
  .back-btn
    position absolute;
    right 50px;
    top 150px;
  .content-right
    .right-button
      border-top 1px solid #e8e8e8e8
      padding 12px 12px
    .el-form-item__label
      float none
      display inline-block
      text-align left
      padding 0 0 10px 0
    .el-form-item__content
      margin-left 0px !important
      .el-checkbox-group
        margin-top -12px
  .preview
    width: 100%
  .idImg
    width: 100px
    cursor: pointer
	
.QR-code {
  width: 250px;
  height: 250px;
}
</style>
